<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px"
  y="0px" viewBox="0 0 18 18" enable-background="new 0 0 18 18" xml:space="preserve">
  <polygon fill="currentColor" points="16,3.707 14.586,2.293 9.293,7.586 4,2.293 2.586,3.707 7.879,9 2.586,14.293 4,15.707
	9.293,10.414 14.586,15.707 16,14.293 10.707,9 " />
</svg>
